import { t } from '@lingui/core/macro'
import ECharts from '~/components/echarts'
import { azureSummaryChartOrganizationOptimizerAzureMasterOptimizationsPath } from '~/routes'

export default function OptimizationSummaryChartOnly({ organizationId, masterOptimizationId }) {
  return (
    <ECharts
      title={t`Optimization Summary`}
      chartInfoTitle='azure_master_optimization_summary'
      url={azureSummaryChartOrganizationOptimizerAzureMasterOptimizationsPath(organizationId)}
      params={{ master_optimization_id: masterOptimizationId }}
    />
  )
}
